import { render } from "./MeasurementDetails.vue?vue&type=template&id=283fd6fd"
import script from "./MeasurementDetails.vue?vue&type=script&lang=js"
export * from "./MeasurementDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__